export const FirebaseConfig = {
  firebase: {
    apiKey: 'AIzaSyBFJ-f68q6ERgg2AGRRw1Iy0VDuxAUDzqk',
    authDomain: 'getshirt-a9ed2.firebaseapp.com',
    databaseURL: 'https://getshirt-a9ed2.firebaseio.com',
    projectId: 'getshirt-a9ed2',
    storageBucket: 'getshirt-a9ed2.appspot.com',
    messagingSenderId: '261013428162',
    appId: '1:261013428162:web:611783625b3a30dc25a85b'
  }
};
